export default function CTASection() {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20lifestyle%20scene%20with%20curated%20shopping%20accessories%20and%20a%20tablet%20device%20on%20a%20light%20wooden%20table%2C%20soft%20golden%20hour%20sunlight%2C%20cream%20beige%20neutral%20tones%2C%20inviting%20retail%20and%20fashion%20editorial%20photography%2C%20elegant%20aspirational%20composition%20with%20gentle%20natural%20glow%2C%20no%20text%20no%20people%2C%20harmonious%20aesthetic&width=1600&height=600&seq=cta-section-v2&orientation=landscape"
          alt="Call to action background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/55 to-black/35"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
          Ready to Explore the Best <strong className="font-heading">Sugargoo Spreadsheet</strong>?
        </h2>
        <p className="text-sm md:text-base text-white/80 max-w-lg mx-auto mb-8">
          Jump into organized product categories, compare prices, and discover thousands of
          vetted finds — all through our comprehensive spreadsheet resources.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-7 py-3.5 text-sm font-semibold bg-accent-500 text-white rounded-md hover:bg-accent-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-accent-500/25"
          >
            Sugargoo Spreadsheet
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-7 py-3.5 text-sm font-semibold bg-white text-foreground-900 rounded-md hover:bg-white/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-shopping-bag-line ml-2"></i>
          </a>
        </div>

        <p className="mt-6 text-xs text-white/50">
          External links open in a new tab · We are an independent resource platform
        </p>
      </div>
    </section>
  );
}